import styled from 'styled-components'
import {device} from '../../media_queries'

const MainBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #ffffff;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 100%;
    height: 100%;
  }
  @media ${device.desktop} {
    
  }
`;

const ClientsCont = styled.div`
    display: flex;
    width: 90vw;
    height: 80vh;
    margin: 2%;
    background-image:url('https://res.cloudinary.com/dojodevs/image/upload/v1580880891/smartia/RECURSOS/SmartiaBackLaptop-01_wiwyyh.png');
    background-size: cover;
    background-position: center;
    color: white;
    
    @media ${device.mobileS} {
    background-image:url('https://res.cloudinary.com/dojodevs/image/upload/v1580882153/smartia/RECURSOS/SmartiaBackMobile-02_s5gwkd.png');
    background-size: 382px 610px;
    height:110vh;
}
    @media ${device.tablet} {  
    background-image:url('https://res.cloudinary.com/dojodevs/image/upload/v1580883419/smartia/RECURSOS/SmartiaBackTablet-01_e10qc7.png');
    background-size: 690px 602px;
    background-position: center;
}
    @media ${device.laptop} {
    background-size: cover;
    background-repeat: no-repeat;
    background-image:url('https://res.cloudinary.com/dojodevs/image/upload/v1580880891/smartia/RECURSOS/SmartiaBackLaptop-01_wiwyyh.png');
}
    @media ${device.desktop} {
    background-image:url('https://res.cloudinary.com/dojodevs/image/upload/v1580880891/smartia/RECURSOS/SmartiaBackLaptop-01_wiwyyh.png');
    background-size: cover;
    background-repeat: no-repeat;
}
`
const ClientesCircle = styled.div`
    display: flex;
    margin-top: 2vh;
    flex-direction: column;
    width: 28vw;
    height: 28vh;
    color: white;
    opacity: 0.9;
    background-image: url('https://res.cloudinary.com/dojodevs/image/upload/v1574746787/smartia/RECURSOS/STOCK_HAL_12_bw8row.jpg');
    background-size: cover;
    background-size: center center;
    -webkit-clip-path: circle(35.5% at 50% 50%);

    @media ${device.mobileS} {

}
    @media ${device.tablet} {
        -webkit-clip-path: circle(25.5% at 50% 50%);
        margin-top: 5vh;
}
    @media ${device.laptop} {
    font-size: 1.5em;
}
    @media ${device.desktop} {
  
}
`
const ClientesCircleR = styled.div`
    display: flex;
    flex-direction: column;
    width: 25vw;
    height: 35vh;
    color: white;
    margin-top: 45vh;
    margin-left:15vw;
    opacity: 0.9;
    background-image: url('https://res.cloudinary.com/dojodevs/image/upload/v1574746787/smartia/RECURSOS/STOCK_HAL_10_luosfn.jpg');
    background-size: cover;

    @media ${device.mobileS} {

}
    @media ${device.tablet} {
        -webkit-clip-path: circle(35.5% at 50% 50%);
}
    @media ${device.laptop} {
  font-size: 1.5em;
}
    @media ${device.desktop} {
  
}
`

export { MainBanner, ClientsCont, ClientesCircle, ClientesCircleR};